import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { Organization } from '../dto/Organization';
import { OrganizationDTO } from '../dto/OrganizationDTO';
import { UrlService } from '../../../../environments/urlService';
import {
  OrganizationUpdateDTO,
} from '../components/shared/modal-organization-update/modal-organization-update.component';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrganizationBackendService {
  private readonly url: string;

  constructor(private urlService: UrlService, private http: HttpClient) {
    this.url = this.urlService.getFmsUrl() + 'organization';
  }

  create(organizationDTO: OrganizationDTO, fundName: string, fundId: number): Observable<OrganizationDTO> {
    return this.http.post<OrganizationDTO>(
      this.url, organizationDTO,
      {
        params: { fundName, fundId },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      });
  }

  update(organizaion: Organization): Promise<Organization> {
    return this.http.put<Organization>(
      this.url, organizaion,
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      })
      .toPromise();
  }

  updateMainInfo(orgUpdateDto: OrganizationUpdateDTO): Observable<Organization> {
    return this.http.put<Organization>(
      this.url + '/main-info', orgUpdateDto, { withCredentials: true },
    ).pipe(
      map((org) => Organization.deserialize(org)));
  }
}
